exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container[data-v-9ad3a81a]{\n    height: auto;\n}\n", ""]);

// exports
